var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F6931E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0018 14.1477C16.8264 14.1477 14.1953 16.7334 14.1953 19.9541C14.1953 23.1749 16.781 25.7606 20.0018 25.7606C23.2225 25.7606 25.8082 23.1295 25.8082 19.9541C25.8082 16.7787 23.1772 14.1477 20.0018 14.1477ZM20.0018 23.6739C17.9604 23.6739 16.282 21.9955 16.282 19.9541C16.282 17.9128 17.9604 16.2344 20.0018 16.2344C22.0431 16.2344 23.7215 17.9128 23.7215 19.9541C23.7215 21.9955 22.0431 23.6739 20.0018 23.6739Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0265 15.3276C26.753 15.3276 27.342 14.7386 27.342 14.0121C27.342 13.2855 26.753 12.6965 26.0265 12.6965C25.2999 12.6965 24.7109 13.2855 24.7109 14.0121C24.7109 14.7386 25.2999 15.3276 26.0265 15.3276Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4355 10.6099C28.256 9.38508 26.5776 8.75 24.6724 8.75H15.3276C11.381 8.75 8.75 11.381 8.75 15.3276V24.627C8.75 26.5776 9.38508 28.256 10.6552 29.4808C11.88 30.6603 13.5131 31.25 15.373 31.25H24.627C26.5776 31.25 28.2107 30.6149 29.3901 29.4808C30.6149 28.3014 31.25 26.623 31.25 24.6724V15.3276C31.25 13.4224 30.6149 11.7893 29.4355 10.6099ZM29.254 24.6724C29.254 26.0786 28.755 27.2127 27.9385 27.9839C27.122 28.755 25.9879 29.1633 24.627 29.1633H15.373C14.0121 29.1633 12.878 28.755 12.0615 27.9839C11.245 27.1673 10.8367 26.0333 10.8367 24.627V15.3276C10.8367 13.9667 11.245 12.8327 12.0615 12.0161C12.8327 11.245 14.0121 10.8367 15.373 10.8367H24.7177C26.0786 10.8367 27.2127 11.245 28.0292 12.0615C28.8004 12.878 29.254 14.0121 29.254 15.3276V24.6724Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.b1b948a2ce532c787da84ddaf815bf85.svg";
export { ForwardRef as ReactComponent };